import React, { useEffect, useState } from "react";
import { submitWaitlist } from "../../api/waitlist";
import { COVERAGE_CITIES } from "../../data/coverage";
import "./ComingSoonModal.css";

const WaitlistForm = ({
  submitLabel = "Notify me",
  onSuccess,
  selectedCity = "",
  onCityChange,
}) => {
  const [email, setEmail] = useState("");
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState(selectedCity);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  useEffect(() => {
    if (selectedCity) {
      setCity(selectedCity);
    }
  }, [selectedCity]);

  const changeCity = (value) => {
    setCity(value);
    if (onCityChange) {
      onCityChange(value);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setStatus("submitting");

    try {
      await submitWaitlist({
        email: email.trim(),
        pincode: pincode.trim(),
        city,
      });
      setStatus("success");
      setEmail("");
      setPincode("");
      setCity("");
      if (onCityChange) {
        onCityChange("");
      }
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      setStatus("idle");
      setError("Something went wrong. Please try again.");
    }
  };

  if (status === "success") {
    return (
      <p className="waitlist-success">
        You’re on the list. We’ll reach out when EldyCare is available in your city.
      </p>
    );
  }

  return (
    <form className="waitlist-form" name="waitlist" onSubmit={handleSubmit}>
      <input type="hidden" name="form-name" value="waitlist" />
      <p className="coming-soon-honeypot">
        <label>
          Don’t fill this out:
          <input name="bot-field" tabIndex="-1" autoComplete="off" />
        </label>
      </p>
      <select
        name="city"
        required
        value={city}
        onChange={(event) => changeCity(event.target.value)}
      >
        <option value="">Select your city</option>
        {COVERAGE_CITIES.map((item) => (
          <option key={item.name} value={item.name}>
            {item.name}
          </option>
        ))}
      </select>
      <input
        type="email"
        name="email"
        required
        placeholder="you@email.com"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
      />
      <input
        type="text"
        name="pincode"
        required
        inputMode="numeric"
        pattern="[0-9]{6}"
        maxLength={6}
        placeholder="Pincode (e.g. 201301)"
        value={pincode}
        onChange={(event) => setPincode(event.target.value.replace(/\D/g, "").slice(0, 6))}
      />
      {error ? <p className="coming-soon-error">{error}</p> : null}
      <button
        className="coming-soon-submit"
        type="submit"
        disabled={status === "submitting"}
      >
        {status === "submitting" ? "Sending…" : submitLabel}
      </button>
    </form>
  );
};

export default WaitlistForm;
